import ServicePageTemplate from "@/pages/services/components/ServicePageTemplate";
import { getServiceDetail } from "@/mocks/services";

export default function StorageServicePage() {
  const detail = getServiceDetail("storage");
  if (!detail) return null;
  return <ServicePageTemplate detail={detail} />;
}